import { defineMessages } from 'react-intl';

export const coreMessages: {
	connectingDots: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pullingThreads: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dialingIn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spoolingThoughts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sparkingIdeas: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	percolating: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ruminating: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	weavingSolutions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jugglingOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	peekingAhead: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	preparing: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	humming: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	coalescing: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gatheringThoughts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	connectingDots: {
		id: 'ai-mate.chat-history.rotating-thinking.connecting-dots',
		defaultMessage: 'Connecting dots',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	pullingThreads: {
		id: 'ai-mate.chat-history.rotating-thinking.pulling-threads',
		defaultMessage: 'Pulling threads',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	dialingIn: {
		id: 'ai-mate.chat-history.rotating-thinking.dialing-in',
		defaultMessage: 'Dialing in',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	spoolingThoughts: {
		id: 'ai-mate.chat-history.rotating-thinking.spooling-thoughts',
		defaultMessage: 'Spooling thoughts',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	sparkingIdeas: {
		id: 'ai-mate.chat-history.rotating-thinking.sparking-ideas',
		defaultMessage: 'Sparking ideas',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	percolating: {
		id: 'ai-mate.chat-history.rotating-thinking.percolating',
		defaultMessage: 'Percolating',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	ruminating: {
		id: 'ai-mate.chat-history.rotating-thinking.ruminating',
		defaultMessage: 'Ruminating',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	weavingSolutions: {
		id: 'ai-mate.chat-history.rotating-thinking.weaving-solutions',
		defaultMessage: 'Weaving solutions',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	jugglingOptions: {
		id: 'ai-mate.chat-history.rotating-thinking.juggling-options',
		defaultMessage: 'Juggling options',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	peekingAhead: {
		id: 'ai-mate.chat-history.rotating-thinking.peeking-ahead',
		defaultMessage: 'Peeking ahead',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	preparing: {
		id: 'ai-mate.chat-history.rotating-thinking.preparing',
		defaultMessage: 'Preparing',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	humming: {
		id: 'ai-mate.chat-history.rotating-thinking.humming',
		defaultMessage: 'Humming',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	coalescing: {
		id: 'ai-mate.chat-history.rotating-thinking.coalescing',
		defaultMessage: 'Coalescing',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
	gatheringThoughts: {
		id: 'ai-mate.chat-history.rotating-thinking.gathering-thoughts',
		defaultMessage: 'Gathering thoughts',
		description: 'Rotating thinking text shown while Rovo is processing a response',
	},
});

export const rareMessages: {
	discombobulating: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	shimmering: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spindling: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	combobulating: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thinkingBrilliantly: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nudgingNeurons: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	discombobulating: {
		id: 'ai-mate.chat-history.rotating-thinking.discombobulating',
		defaultMessage: 'Discombobulating',
		description: 'Rare rotating thinking text shown while Rovo is processing a response',
	},
	shimmering: {
		id: 'ai-mate.chat-history.rotating-thinking.shimmering',
		defaultMessage: 'Shimmering',
		description: 'Rare rotating thinking text shown while Rovo is processing a response',
	},
	spindling: {
		id: 'ai-mate.chat-history.rotating-thinking.spindling',
		defaultMessage: 'Spindling',
		description: 'Rare rotating thinking text shown while Rovo is processing a response',
	},
	combobulating: {
		id: 'ai-mate.chat-history.rotating-thinking.combobulating',
		defaultMessage: 'Combobulating',
		description: 'Rare rotating thinking text shown while Rovo is processing a response',
	},
	thinkingBrilliantly: {
		id: 'ai-mate.chat-history.rotating-thinking.thinking-brilliantly',
		defaultMessage: 'Thinking brilliantly',
		description: 'Rare rotating thinking text shown while Rovo is processing a response',
	},
	nudgingNeurons: {
		id: 'ai-mate.chat-history.rotating-thinking.nudging-neurons',
		defaultMessage: 'Nudging neurons',
		description: 'Rare rotating thinking text shown while Rovo is processing a response',
	},
});

/**
 * Number of rare messages to include per rotation cycle.
 * With 14 core + 2 rare ≈ 12% rare frequency.
 */
export const RARE_MESSAGES_PER_CYCLE = 2;
